export const transactionTableColWidths = {
  serial: "3%",
  product: "28%",
  code: "9%",
  model: "9%",
  gst: "5%",
  mrp: "7%",
  rate: "7%",
  qty: "6%",
  discount: "7%",
  gstValue: "6%",
  taxable: "8%",
  total: "8%",
} as const;

/** Minimum width for product name column (~20 characters at 13px). */
export const transactionProductColMinWidth = "280px";

export const transactionTableStyle = {
  tableLayout: "fixed" as const,
  width: "100%",
  marginBottom: 0,
};

/** Wide purchase / purchase-return tables: allow horizontal scroll so amount columns stay readable. */
export const transactionTableWideStyle = {
  width: "100%",
  minWidth: "3000px",
  marginBottom: 0,
};

export const transactionTableHeaderStyle = (width?: string) => ({
  ...(width ? { width } : {}),
  padding: "7px 5px",
  fontSize: "13px",
  whiteSpace: "nowrap" as const,
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const transactionTableCellStyle = (width?: string) => ({
  ...(width ? { width } : {}),
  padding: 0,
  fontSize: "13px",
  verticalAlign: "top" as const,
});

export const transactionTableInputStyle = {
  minWidth: "5.75rem",
};

export const transactionTableReadOnlyInputClass = "form-control-sm px-1 text-end";
export const transactionTableEditableInputClass = "form-control-sm px-1 text-end";
export const transactionTableTextInputClass = "form-control-sm px-1";

/** Fixed / min widths for wide purchase / purchase-return line-item tables. */
export const purchaseTableColWidths = {
  serial: "40px",
  product: "280px",
  code: "110px",
  model: "110px",
  hsn: "90px",
  gst: "70px",
  batch: "80px",
  expiry: "110px",
  qty: "80px",
  free: "70px",
  /** Money / amount columns (P.Rate, PWOG, Net Amt, etc.) */
  amount: "100px",
  percent: "80px",
  action: "72px",
} as const;

export const purchaseTableFocusedInputClass = (
  fieldKey: string,
  focusedField: string | null,
) =>
  focusedField === fieldKey
    ? `${transactionTableEditableInputClass} border border-2 border-primary rounded`
    : transactionTableEditableInputClass;
